import {simpleRequest} from "../apiConfigs/request";

export const fetchProposal = (proposalUuid) => {
    return simpleRequest({
        url: `/proposal/public/${proposalUuid}`,
        method: 'GET'
    });
}

export const saveProposalStatus = (proposalUuid, data) => {
    return simpleRequest({
        url: `/proposal/public/${proposalUuid}`,
        method: 'PATCH',
        data,
    });
}
